import { i18n } from '@wms/shared';

export function SessionExpired({
  onRetry = () => window.location.reload(),
}: {
  onRetry?: () => void;
}) {
  return (
    <main className="min-h-screen flex items-center justify-center p-4">
      <section role="alert" className="w-full max-w-md rounded border bg-card p-6 space-y-4">
        <p>{i18n.t('auth.session.expired')}</p>
        <button
          type="button"
          className="w-full rounded bg-primary text-primary-foreground py-2 text-sm font-medium"
          onClick={onRetry}
        >
          {i18n.t('auth.session.sign_in_again')}
        </button>
      </section>
    </main>
  );
}
